// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"bc448408","225":"47ba45b2","502":"dec4c112","631":"47ba45b2","672":"47ba45b2","678":"47ba45b2","707":"bc448408","849":"bc448408"}[chunkId] + ".chunk.css";
};